export class AuthRequestModel {
    userid = '';
    password = '';
}
